import React from "react";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { GenericDropdownItem } from "@sonder/ui/source/styled/fragments/GenericDropdownItem";
import { SearchDropdownTrigger } from "@sonder/ui/source/styled/fragments/SearchDropdownTrigger";
import { colors } from "@sonder/ui/source/styled/theme";
import { StatusFilter, updateStatusFilterText } from "search/actions";
import { useSearchStore } from "search/store";

const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;

const StatusDropdownContent = styled(DropdownContent)`
  flex-direction: column;
`;

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)`
  color: ${colors.grayE};
`;

const createTrigger = (text: StatusFilter) => (
  <SearchDropdownTrigger iconRight iconSize="1.714rem">
    <div>{text}</div>
    <StyledKeyboardArrowDownIcon />
  </SearchDropdownTrigger>
);

export const SearchStatusDropdown = () => {
  const { state, dispatch } = useSearchStore();

  const dropdownOptions: StatusFilter[] = [
    StatusFilter.AllResults,
    StatusFilter.Complete,
    StatusFilter.Incomplete,
  ];

  return (
    <StyledDropdown trigger={createTrigger(state.statusFilterText)}>
      {({ isOpen, closePortal }) =>
        isOpen && (
          <StatusDropdownContent>
            {dropdownOptions.map(statusFilter => {
              return (
                <GenericDropdownItem
                  key={statusFilter}
                  onClick={() => {
                    dispatch(updateStatusFilterText(statusFilter));
                    closePortal();
                  }}
                >
                  {statusFilter}
                </GenericDropdownItem>
              );
            })}
          </StatusDropdownContent>
        )
      }
    </StyledDropdown>
  );
};
